import { IAppSettings } from "model/common/app-settings";

let settings: Promise<IAppSettings> | null = null;

export const getAppSettings = async (): Promise<IAppSettings> => {
  if (settings) return settings;

  settings = fetch('/settings.json').then(x => x.json());
  return await settings;
};
